import { createIdentifier } from '@wendellhu/redi';

export interface HttpConfig {
  params?: Record<string, unknown>;
  headers?: Record<string, string>;
}

export interface IHttpService {
  get<T>(url: string, params?: Record<string, unknown>): Promise<T>;
  post<T>(url: string, data?: unknown, config?: HttpConfig): Promise<T>;
  put<T>(url: string, data?: unknown, config?: HttpConfig): Promise<T>;
  patch<T>(url: string, data?: unknown, config?: HttpConfig): Promise<T>;
  delete<T>(url: string, config?: HttpConfig): Promise<T>;
}

export const IHttpServiceToken = createIdentifier<IHttpService>('core.http');
